<script>
import apigeneric from "@/helpers/apigeneric";
export default {
  mixins: [apigeneric],
  data() {
    return {
      NewsData: {},
      Created: ""
    };
  },
  components: {},
  methods: {
    getLang() {
      return localStorage.getItem("lang") || "tr";
    },
    getFirstImage(gallery) {
      if (gallery && typeof gallery === 'string' && gallery.trim() !== '') {
        return gallery.split(',')[0].trim();
      }
      return '';
    },
    handleImgError(e) {
      e.target.style.display = 'none';
      if (e.target.parentElement) {
        const fallback = e.target.parentElement.querySelector('.img-fallback-icon');
        if (fallback) fallback.style.display = 'flex';
      }
    },
    Get() {
      let Page = {
        PageNumber: "1",
        PageSize: "3",
        PageDataSize: "1",
      };
      this.ActionsFilterGet({
        Service: "News",
        Page: Page,
        Filter:
          "&Asc=Startdate" + 
          "&Newstype=2&Websiteid=" +
          window.$cookies.get("ecampuswebsite"),
      }).then((res) => {
        this.NewsData = res.Data;
      });

     


     

      
    },
  },
};
</script>

<template>
  <section>
    <div class="home-news">
      <div class="title c-flex flex-column">
        <a :href="'/fullnews/tr'" class="card-link"><h3>{{$t("dashboards.NewsTitle")}}</h3></a>
        <p>{{$t("dashboards.NewsDescription")}}</p>
      </div>
      <div class="container">
        <div class="row align-items-stretch">
          <div
            class="col-md-4 mb-4 d-flex align-items-stretch"
            v-for="(Data, index) in NewsData"
            :key="index"
          >
            <div class="card w-100 d-flex flex-column">
              <div class="card-img-wrapper">
                <img
                  v-if="getFirstImage(Data.Imagegallery)"
                  :src="$config.FILES_URL + 'web/' + getFirstImage(Data.Imagegallery)"
                  class="card-img-top"
                  alt=""
                  @error="handleImgError"
                />
                <div class="img-fallback-icon" :style="{ display: getFirstImage(Data.Imagegallery) ? 'none' : 'flex' }">
                  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="#ffffff" opacity="0.85" viewBox="0 0 16 16">
                    <path d="M0 2.5A1.5 1.5 0 0 1 1.5 1h11A1.5 1.5 0 0 1 14 2.5v10.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 13V2.5zM1.5 2a.5.5 0 0 0-.5.5v10.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V2.5a.5.5 0 0 0-.5-.5h-11z"/>
                    <path d="M3 4h8v1H3V4zm0 3h8v1H3V7zm0 3h5v1H3v-1z"/>
                  </svg>
                </div>
              </div>
              <div class="card-body d-flex flex-column flex-grow-1">
                <h5 class="card-date">{{ Data.Startdate | formatDateTime }}</h5>
                <h5 class="card-title mt-3">
                  {{ Data.Title }}
                </h5>
                <p class="card-text flex-grow-1">
                  <span v-html="Data.Description"></span><br />
                </p>
                <a :href="'/NewsDetail/tr/'+ Data.Title.toLowerCase()
                                    .replace(/I|İ/gi, 'i')
                                    .replace(/Ğ|ğ/gi, 'g')
                                    .replace(/Ç|ç|ğ/gi, 'c')
                                    .replace(/\s+/g, '-')
                                    .replace(/&/g, `-and-`)
                                    .replace(/--/g, `-`) + '/'
                 + Data.Id" class="card-link mt-auto"
                  > {{$t("OrtakKullanim.ReadMore")}} →</a
                >
               
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center mt-4">
          <a :href="'/fullnews/' + getLang()" class="btn-more-show">
            Daha Fazla Göster &rarr;
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.home-news .card {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.home-news .card .card-body {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
}
.home-news .card .card-body .card-text {
  flex-grow: 1;
}
.home-news .card .card-body .card-link {
  margin-top: auto;
}
.card-img-wrapper {
  width: 100%;
  height: 200px;
  background-color: #00758f;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.home-news .card .card-img-top {
  width: 100%;
  height: 200px;
  object-fit: contain;
  background-color: #00758f;
}
.img-fallback-icon {
  width: 100%;
  height: 100%;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #00758f;
}
.btn-more-show {
  display: inline-block;
  background-color: #00758f;
  color: #ffffff !important;
  font-weight: 700;
  font-size: 14px;
  padding: 10px 30px;
  border-radius: 30px;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 4px 10px rgba(0, 117, 143, 0.2);
}
.btn-more-show:hover {
  background-color: #005a6e;
  color: #ffffff !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(0, 117, 143, 0.35);
}
</style>
